import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./plugins/confirmDialog";
import "./plugins/alertDialog";
import "./styles/design-system.scss";
import ModalHeader from "@/components/common/ModalHeader.vue";
import MobileRecordCard from "@/components/common/MobileRecordCard.vue";
import responsive from "@/mixins/responsive.js";
import axios from "axios";
import VueHtmlToPaper from "vue-html-to-paper";
import firebase from "firebase/compat/app";
import "firebase/storage";
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=no", "scrollbars=yes"],
  styles: [
    "https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css",
  ],
  timeout: 50000,
  autoClose: true, // Auto-close print dialog after printing
  windowTitle: "JMB Print", // Window title
};
const firebaseConfig = {
  apiKey: "AIzaSyCTNzR1tInyiCytA2j7t4bxiA-bwDlmUus",
  authDomain: "jmbcomputers.firebaseapp.com",
  projectId: "jmbcomputers",
  storageBucket: "jmbcomputers.appspot.com",
  messagingSenderId: "420884036697",
  appId: "1:420884036697:web:faa0cc9667b8346e5d4548",
  measurementId: "G-5YSCMPCQJ1",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

Vue.use(VueHtmlToPaper, options);

// Global design-system components (see DESIGN_GUIDELINES.md)
Vue.component("ModalHeader", ModalHeader);
Vue.component("MobileRecordCard", MobileRecordCard);

// Global responsive helpers — exposes `isMobile`/`isPhone`/`isTablet` on every
// component (see src/mixins/responsive.js). No component currently defines
// these names, so the global mixin is collision-free.
Vue.mixin(responsive);

// for authenticating thru headers with tokens
require("@/store/subscriber");
Vue.config.productionTip = false;
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

// Whenever an API response reports an SMS attempt (customer registration,
// unit status change, invoice, payment, downpayment), show a snackbar so the
// user knows the text message went out (or why it didn't).
axios.interceptors.response.use((response) => {
  const sms = response.data && response.data.sms_notification;
  if (sms && sms.status) {
    if (sms.status === "sent") {
      store.dispatch("notification/set_notification", {
        type: "success",
        message: "Text message sent to " + sms.recipient,
      });
    } else {
      store.dispatch("notification/set_notification", {
        type: "error",
        message: "Text message NOT sent" + (sms.error ? " — " + sms.error : ""),
      });
    }
  }
  return response;
}, (error) => {
  // Transient DB-connection failures on shared hosting. When the Dashboard
  // mounts it fires ~a dozen widget requests at once; that burst can briefly
  // trip the host's per-account connection/process limit, so one request comes
  // back as a 500 carrying "SQLSTATE[HY000] [2002] Operation not permitted"
  // (the DB connect, not a query, failed). Retrying that single idempotent GET
  // after a short delay — once the burst has drained — succeeds. Only GETs are
  // retried (never mutating POST/PUT/DELETE), and only for this signature.
  const config = error.config;
  const status = error.response && error.response.status;
  const body = error.response && error.response.data;
  const text = typeof body === "string" ? body : JSON.stringify(body || {});
  const isTransientDb =
    (!error.response || status === 500 || status === 503) &&
    /\[2002\]|Operation not permitted|Too many connections|max_user_connections|SQLSTATE\[HY000\]/i.test(
      text || (error.message || "")
    );
  const method = config && (config.method || "get").toLowerCase();
  if (config && method === "get" && isTransientDb) {
    config.__dbRetry = (config.__dbRetry || 0) + 1;
    if (config.__dbRetry <= 2) {
      const delay = 400 * config.__dbRetry + Math.floor(Math.random() * 250);
      return new Promise((resolve) => setTimeout(resolve, delay)).then(() =>
        axios(config)
      );
    }
  }
  return Promise.reject(error);
});

store.dispatch("auth/attempt", localStorage.getItem("token")).then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
});
